import { twoItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { translate } from 'i18n/i18n'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const fireBlightTRV: typeof valueTypeRenderers.fireBlightTRV = {
  label: () => unitConverter.fireBlight().titleWithoutUnit(),
  block: ({ metadata }) => {
    const baseLabel = unitConverter.fireBlight().title()

    const label =
      metadata.aggregationInterval === 'DAILY'
        ? twoItemLabel([baseLabel, translate.phrases.abbreviations('Maximum')])
        : baseLabel

    return (n) => {
      return [
        {
          id: 'value',
          label: label,
          value: unitConverter.fireBlight(n).valueAsString(),
        },
      ]
    }
  },
}
